import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions"; 
import { getStorage } from "firebase/storage"; // 1. NEW: Import Storage

const firebaseConfig = {
  apiKey: "AIzaSyBL6bIpU3MBVbxawkS_0VIx4Usg29v4tC4",
  authDomain: "whatsappait.firebaseapp.com",
  projectId: "whatsappait",
  storageBucket: "whatsappait.firebasestorage.app",
  messagingSenderId: "921931904439",
  appId: "1:921931904439:web:4920f088d396bf96a22432"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app); 
export const functions = getFunctions(app); 
export const storage = getStorage(app); // 2. NEW: Initialize and export Storage